import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Paging from "biz-ts/src/api/Paging";
import DeviceMqttEventEventWrapper from "@/model/DeviceMqttEventWrapper";
import {DmqttEventPqForm} from "@/form/DeviceMqttForm";
import ObjectUtil from 'tools-ts/src/util/ObjectUtil';
import _ from 'lodash';

@Singleton
export default abstract class DeviceMqttEventApi {
    abstract paging(form: DmqttEventPqForm): Promise<Paging<DeviceMqttEventEventWrapper>>
}

class DeviceMqttEventApiImpl extends BaseApi implements DeviceMqttEventApi {

    protected urlPrefix = 'device/mqtt/event'

    async paging(form: DmqttEventPqForm): Promise<Paging<DeviceMqttEventEventWrapper>> {
        const f = ObjectUtil.deepClone(form)
        if (_.isEmpty(f.eventTypes)) f.eventTypes = []
        if (_.isEmpty(f.clientTypes)) f.clientTypes = []
        if (_.isEmpty(f.payload)) f.payload = undefined
        const paging: Paging<DeviceMqttEventEventWrapper> = await this.axios.post('paging', f)
        paging.content.forEach(wrapper => {
            wrapper.mqttEventWrapper.eventJson = JSON.stringify(wrapper.mqttEventWrapper.event)
        })
        return paging
    }
}

Container.bind(DeviceMqttEventApi).to(DeviceMqttEventApiImpl)
